export default __webpack_public_path__ + "static/media/image-airfilter.268fdba1.jpg";